module.exports = new __parcel__URL__("vater.e9a2b41a.png").toString();